import { makeStyles } from '@material-ui/core/styles';

export const useStyles = makeStyles((theme: any) => ({
  MainSidebarHeaderOpen: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    overflow: 'hidden',
  },
  MainSidebarHeaderClose: {
    transition: 'all ease 0.3s',
    display: 'flex',
    justifyContent: 'center',
    '& img': {
      transition: 'all ease 0.3s',
      display: 'block',
      maxWidth: '46px',
    },
  },
  MainSidebarHeaderToggler: {
    cursor: 'pointer',
  },
  logo: {
    display: 'flex',
    alignItems: 'flex-end',
    textDecoration: 'none',
    '& img': {
      display: 'block',
    },
  },
  beta: {
    color: '#fff',
    marginBottom: '4px',
    marginLeft: '8px',
    fontWeight: 500,
    fontSize: '16px',
  },
}));
